<template>
	<div>
		<div class="public-table-but__left">
			<div class="item">
				<!-- <em>筛选：</em> -->
				<div class="item-wp">
					<template>
						<div class="item-son">
							<el-input
								v-model="listParams.searchKey"
								placeholder="搜索关键词"
								clearable
								@keyup.enter.native="SearchAppList"
							></el-input>
						</div>
						<div class="item-son" style="width: 180px">
							<el-select
								filterable
								v-model="listParams.companyId"
								clearable
								placeholder="请选择主体"
								style="width: 100%"
							>
								<el-option
									v-for="(item, index) in companyData"
									:key="index"
									:label="item.name"
									:value="item.companyId"
								></el-option>
							</el-select>
						</div>
						<div class="item-son">
							<el-select
								v-model="listParams.status"
								clearable
								placeholder="请选择状态"
								style="width: 120px"
							>
								<el-option label="正常" value="1"></el-option>
								<el-option label="禁用" value="0"></el-option>
							</el-select>
						</div>
						<div class="item-son">
							<el-button type="primary" @click="SearchAppList"
								>查询 <i class="el-icon-search"></i>
							</el-button>
						</div>
					</template>
					<div class="item-son">
						<el-button type="primary" @click="handleClick('add')"
							>新增 <img src="@assets/images/add-icon.png" alt="" />
						</el-button>
					</div>
				</div>
			</div>
		</div>
		<div class="public-table-data">
			<el-table
				ref="multipleTable"
				size="medium"
				:data="tableData"
				border
				style="width: 100%"
				row-key="menuId"
				v-loading="loading"
			>
				<el-table-column type="index" label="序号" width="80" align="center">
				</el-table-column>
				<el-table-column prop="appLogo" label="Logo" width="120" align="center">
					<template slot-scope="scope">
						<el-image
							v-if="scope.row.appLogo"
							style="width: 50px; height: 50px"
							:src="scope.row.appLogo"
							fit="cover"
						></el-image>
					</template>
				</el-table-column>
				<el-table-column prop="swid" label="SWID" width="100" align="center">
				</el-table-column>
				<el-table-column prop="appName" label="名称" width="140" align="center">
				</el-table-column>
				<el-table-column
					prop="companyVo"
					label="主体"
					width="200"
					align="center"
				>
					<template slot-scope="scope">
						{{ scope.row.companyVo ? emptyShow(scope.row.companyVo.name) : "" }}
					</template>
				</el-table-column>
				<el-table-column
					prop="websitType"
					label="类型"
					width="180"
					align="center"
				>
				</el-table-column>
				<el-table-column prop="ctime" label="时间" width="180" align="center">
				</el-table-column>
				<el-table-column prop="code" label="状态" width="100" align="center">
					<template slot-scope="scope">
						<el-switch
							v-model="scope.row.status"
							:active-value="1"
							:inactive-value="0"
							@change="changeSwitch(scope.row)"
						>
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column
					label="操作"
					align="left"
					fixed="right"
					min-width="220"
				>
					<template slot-scope="scope">
						<el-button
							size="mini"
							@click="handleClick('edit', scope.row)"
							type="success"
							plain
							>编辑
						</el-button>

						<el-button
							size="mini"
							@click="handleClick('content', scope.row)"
							type="warning"
							plain
							>内容
						</el-button>
						<el-button
							size="mini"
							@click="handleClick('channel', scope.row)"
							type="warning"
							plain
							style="margin-bottom: 10px"
							>渠道
						</el-button>
						<el-button
							size="mini"
							@click="handleClick('nav', scope.row)"
							type="success"
							plain
							>导航
						</el-button>
						<el-button
							size="mini"
							@click="handleClick('lang', scope.row)"
							type="primary"
							plain
							>语言
						</el-button>
            <el-button
                size="mini"
                @click="handlePaymentMethodClick(scope.row)"
                type="primary"
                plain
            >策略
            </el-button>
						<el-button
							size="mini"
							@click="handleDelete(scope.row)"
							type="danger"
							plain
							>删除
						</el-button>
						<el-button
							size="mini"
							@click="handleClick('vip', scope.row)"
							type="warning"
							plain
							>会员
						</el-button>
            <el-button
                size="mini"
                @click="handlePaymentClick(scope.row)"
                type="danger"
                plain
            >支付
            </el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<div class="public-pagination">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pages.pageNo"
					:page-sizes="[PAGE_SIZE, 50, 100, 200, 400]"
					:page-size="pages.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				>
				</el-pagination>
			</div>
		</div>
		<!-- 编辑弹框 -->
		<el-dialog
			:title="
				clickType == 'add'
					? '新增应用信息'
					: clickType == 'channel'
					? '关联渠道'
					: clickType == 'edit'
					? '编辑应用'
					: clickType == 'pay'
					? '关联支付'
					: clickType == 'lang'
					? '绑定语言'
					: clickType == 'nav'
					? '配置导航'
					: ''
			"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			width="820px"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<el-form
					ref="ruleForm"
					:rules="rules"
					:model="params"
					label-width="110px"
				>
					<div v-if="clickType == 'add' || clickType == 'edit'">
						<el-row>
							<el-col :span="12">
								<el-form-item class="item" label="LOGO">
									<upLoadImg
										:keyWord="'appLogo'"
										:params="params"
										v-if="flag"
									></upLoadImg>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item class="item" label="二维码">
									<upLoadImg
										:keyWord="'qrcode'"
										:params="params"
										v-if="flag"
									></upLoadImg>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="名称" prop="appName">
									<el-input
										clearable
										placeholder="应用名称"
										v-model="params.appName"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="类型" required prop="appType">
									<el-select
										filterable
										style="width: 100%"
										v-model="params.appType"
										clearable
										placeholder="请选择"
										:disabled="clickType == 'edit' ? true : false"
									>
										<el-option
											v-for="item in allAppType"
											:key="item.enumVal"
											:label="item.enumName"
											:value="item.enumVal"
										>
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col :span="12">
								<el-form-item label="应用ID" prop="appid">
									<el-input
										clearable
										placeholder="如果不填写,系统将自动生成"
										v-model="params.appid"
										:disabled="clickType == 'edit' ? true : false"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="SWID" prop="swid">
									<el-input
										clearable
										placeholder="应用推广标识"
										v-model="params.swid"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="邮箱">
									<el-select
										v-model="params.fromEmail"
										clearable
										style="width: 100%"
										placeholder="请选择状态"
									>
										<el-option
											v-for="(item, index) in emailList"
											:value="item.id"
											:key="index"
											:label="item.name"
										></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="网站类型">
									<el-input
										clearable
										placeholder="请填写网站类型"
										v-model="params.websitType"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="主题">
									<el-select
										filterable
										style="width: 100%"
										v-model="params.subject"
										clearable
										placeholder="请选择"
									>
										<el-option label="小男孩黄色" value="yellow_boy">
										</el-option>
										<el-option label="小女孩黄色" value="yellow_girl">
										</el-option>
										<el-option label="黄色电脑" value="yellow_computer">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item required label="主体" prop="companyId">
									<el-select
										v-model="params.companyId"
										clearable
										filterable
										placeholder="请选择主体"
										@change="changeMain"
										style="width: 100%"
										:disabled="clickType == 'edit' ? true : false"
									>
										<el-option
											v-for="(item, index) in companyData"
											:key="index"
											:label="item.name"
											:value="item.companyId"
										></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item required label="业务域名" prop="domainBizId">
									<el-select
										v-model="params.domainBizId"
										clearable
										filterable
										placeholder="请选择业务域名"
										style="width: 100%"
										:disabled="
											params.companyId && params.companyId != '' ? false : true
										"
									>
										<el-option
											v-for="item in allDomainList"
											:key="item.domainBizId"
											:label="item.domainBizAddress"
											:value="item.domainBizId"
										>
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="内部说明">
									<el-input
										type="textarea"
										:rows="4"
										maxlength="200"
										placeholder="最长为200个字符"
										v-model="params.descr"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="外部介绍">
									<el-input
										type="textarea"
										:rows="4"
										maxlength="200"
										placeholder="最长为200个字符"
										v-model="params.intro"
									></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<!-- 微信//app分开 -->
					</div>

					<!-- 渠道 -->
					<el-row v-if="clickType == 'channel'">
						<el-form-item label="名称：">
							<span v-if="params.companyVo"
								>{{ params.companyVo.name }} ( {{ params.appName }} )</span
							>
						</el-form-item>
						<el-form-item label="应用ID：">
							<span v-if="params.appid">{{ params.appid }}</span>
						</el-form-item>
						<el-form-item label=" 渠道：" prop="channelAccountIds">
							<el-select
								v-model="params.channelAccountIds"
								clearable
								multiple
								no-data-text="暂无渠道"
								placeholder="请选择渠道"
								filterable
								style="width: 100%"
								@change="$forceUpdate()"
							>
								<el-option
									v-for="(item, index) in channelData"
									:key="`${index}`"
									:label="`[${item.channelTypeName}] - ${item.account} -（ ${item.code} )`"
									:value="item.channelAccountId"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-row>
					<!-- 导航 -->
					<el-row v-if="clickType == 'nav'">
						<el-form-item label="名称：">
							<span v-if="params.companyVo"
								>{{ params.appName }}({{ params.appTypeName }})</span
							>
						</el-form-item>
						<el-form-item label="应用ID：">
							<span v-if="params.appid">{{ params.appid }}</span>
						</el-form-item>
						<el-form-item label="导航：">
							<el-checkbox-group v-model="checkListNav">
								<el-checkbox
									v-for="(item, idx) in navList"
									:key="idx"
									:label="item.appNavId"
									>{{ item.name }}
								</el-checkbox>
							</el-checkbox-group>
						</el-form-item>
					</el-row>
					<el-row v-if="clickType == 'lang'">
						<el-form-item label="名称：">
							<span v-if="params.companyVo"
								>{{ params.appName }}({{ params.appTypeName }})</span
							>
						</el-form-item>
						<el-form-item label="应用ID：">
							<span v-if="params.appid">{{ params.appid }}</span>
						</el-form-item>
						<el-form-item label="语言：">
							<el-checkbox-group v-model="bindLanguageList">
								<el-checkbox
									v-for="item in languageList"
									:key="item.code"
									:label="item.code"
								>
									{{ item.name }}
								</el-checkbox>
							</el-checkbox-group>
						</el-form-item>
					</el-row>
				</el-form>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogVisible = false"
					>取 消</el-button
				>
				<el-button size="medium" type="primary" @click="handleEdit"
					>提 交</el-button
				>
			</span>
		</el-dialog>
		<el-dialog
        title="关联支付（已弃用，修改无效）"
			:visible.sync="paymentVistab"
			:close-on-click-modal="false"
			width="800px"
			class="public-dialog"
		>
			<div class="public-dialog-form" style="padding-bottom: 20px">
				<!-- 支付 -->
				<el-row style="margin-bottom: 15px">
					<el-col :span="21">
						<div class="app_info_name">
							应用名称：{{ params.appName }}（{{ params.appTypeName }}）
						</div>
					</el-col>
					<el-col :span="3">
						<el-button
							type="primary"
							style="margin-right: 0"
							@click="handPaymentClick('add')"
							size="mini"
							>添加商户
						</el-button>
					</el-col>
				</el-row>
				<el-tabs
					v-model="chilckType"
					type="card"
					@tab-click="activePayEventNav"
				>
					<el-tab-pane
						v-for="(item, index) in payType"
						:key="index"
						:label="item.name"
						:name="item.type"
					></el-tab-pane>
				</el-tabs>
				<el-table
					ref="multipleTable"
					size="medium"
					:data="payMentListInfo"
					border
					style="width: 100%"
					row-key="menuId"
					v-loading="loading"
				>
					<el-table-column type="index" label="序号" width="50" align="center">
					</el-table-column>
					<el-table-column label="商户名称" align="center">
						<template slot-scope="scope">
							{{ scope.row.paymentMch.mchName }}
						</template>
					</el-table-column>
					<el-table-column label="商户ID" width="140" align="center">
						<template slot-scope="scope">
							{{ scope.row.paymentMch.mchId }}
						</template>
					</el-table-column>
					<el-table-column prop="sort" label="排序" width="140" align="center">
						<template slot-scope="scope">
							<el-input
								v-model="scope.row.sort"
								size="mini"
								type="text"
								@blur="saveSort(scope.row)"
							></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="code" label="状态" width="80" align="center">
						<template slot-scope="scope">
							<el-switch
								v-model="scope.row.status"
								:active-value="1"
								:inactive-value="0"
								@change="changePaymentSwitch(scope.row)"
							>
							</el-switch>
						</template>
					</el-table-column>
					<el-table-column
						label="操作"
						align="center"
						fixed="right"
						width="160"
					>
						<template slot-scope="scope">
							<!-- <el-button
                  size="mini"
                  @click="handPaymentClick('edit', scope.row)"
                  type="success"
                  plain
              >编辑
              </el-button> -->
							<el-button
								size="mini"
								@click="handlePaymentDelete(scope.row)"
								type="danger"
								plain
								>删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>

    <el-dialog
        title="支付策略"
        :visible.sync="paymentMethodVisible"
        :close-on-click-modal="false"
        width="80%"
        class="public-dialog"
    >
      <div class="public-dialog-form" style="padding-bottom: 20px">
        <!-- 支付 -->
        <el-row style="margin-bottom: 15px">
          <el-col :span="21">
            <div class="app_info_name">
              应用名称：{{ params.appName }}（{{ params.appTypeName }}）
            </div>
          </el-col>
          <el-col :span="3">
            <el-button
                type="primary"
                style="margin-right: 0"
                @click="handPaymentMethodClick('add')"
                size="mini"
            >添加
            </el-button>
          </el-col>
        </el-row>
        <el-table
            ref="multipleTable"
            size="medium"
            :data="paymentMethodList"
            border
            style="width: 100%"
            row-key="menuId"
            v-loading="loading"
        >
          <el-table-column type="index" label="序号" width="50" align="center">
          </el-table-column>
          <el-table-column label="切换策略" width="140" align="center">
            <template slot-scope="scope">
              <span>访问 <el-tag size="mini">{{ scope.row.changeCount }}</el-tag> 次</span>
            </template>
          </el-table-column>
          <el-table-column label="支付类型" width="140" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.paymentType }}</span>
            </template>
          </el-table-column>
          <el-table-column label="商户类型" align="center">
            <template slot-scope="scope">
              {{ scope.row.mchType }}
            </template>
          </el-table-column>
          <el-table-column label="商户名称" align="center">
            <template slot-scope="scope">
              {{ scope.row.mchName }}
            </template>
          </el-table-column>
          <el-table-column label="商户ID" width="140" align="center">
            <template slot-scope="scope">
              {{ scope.row.paymentMchId }}
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序" width="140" align="center">
            <template slot-scope="scope">
              {{ scope.row.sort }}
            </template>
          </el-table-column>
          <el-table-column prop="code" label="状态" width="80" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 1" type="success">启用</el-tag>
              <el-tag v-if="scope.row.status === 0" type="info">禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column
              label="操作"
              align="center"
              fixed="right"
              width="160"
          >
            <template slot-scope="scope">
              <el-row>
                <el-col :span="12">
                  <el-link
                      size="mini"
                      @click="handPaymentMethodClick('edit',scope.row)"
                      type="primary"
                      plain
                      icon="el-icon-edit"
                  >修改
                  </el-link>
                </el-col>
                <el-col :span="12">
                  <el-link
                      size="mini"
                      @click="handlePaymentMethodDelete(scope.row)"
                      type="danger"
                      icon="el-icon-close"
                      plain
                  >删除
                  </el-link>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
		<el-dialog
			title="关联支付-添加/编辑商户"
			:visible.sync="paymentMerchantVisble"
			:close-on-click-modal="false"
			width="600px"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<!-- 支付 -->
				<div class="public-dialog-form">
					<el-form
						ref="ruleForm"
						:rules="payRules"
						:model="payParams"
						label-width="80px"
					>
						<el-form-item label="商户名称">
							<el-select
								:disabled="paymentClickType == 'edit'"
								filterable
								style="width: 100%"
								v-model="payParams.paymentMchId"
								clearable
								placeholder="请选择商户"
							>
								<el-option
									v-for="(item, index) in allPayInfoList"
									:key="index"
									:label="item.mchName + '(' + item.mchId + ')'"
									:value="item.paymentMchId"
								>
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="排序" prop="sort">
							<el-input
								clearable
								placeholder="排序"
								v-model="payParams.sort"
							></el-input>
						</el-form-item>
					</el-form>
				</div>
				<span
					slot="footer"
					class="public-dialog-footer"
					style="padding-top: 20px"
				>
					<el-button size="medium" @click="paymentMerchantVisble = false"
						>取 消</el-button
					>
					<el-button size="medium" type="primary" @click="handleMchID"
						>提 交</el-button
					>
				</span>
			</div>
		</el-dialog>
		<el-dialog
			title="会员-添加/编辑"
			:visible.sync="vipVisble"
			width="800px"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<!-- 支付 -->
				<div class="public-dialog-form">
					<el-form ref="ruleForm" :model="vipParams" label-width="80px">
						<el-form-item label="会员名称" name="name">
							<el-input
								clearable
								placeholder="会员名称"
								v-model="vipParams.name"
							></el-input>
						</el-form-item>
						<el-tabs
							type="card"
							v-model="languageCode"
							@tab-click="handleTabClick('vip')"
						>
							<el-tab-pane
								v-for="(item, index) in languageList"
								:label="item.name"
								:name="item.code"
								:key="index"
							></el-tab-pane>
						</el-tabs>
						<el-form-item label="会员内容" prop="description">
							<el-input
								v-model="vipParams.description"
								placeholder="会员内容"
								type="textarea"
								:autosize="{ minRows: 18, maxRows: 22 }"
							/>
						</el-form-item>
					</el-form>
				</div>
				<span slot="footer" class="public-dialog-footer">
					<el-button size="medium" @click="vipVisble = false">取 消</el-button>
					<el-button size="medium" type="primary" @click="handleVip">
						提 交
					</el-button>
					<el-button
						v-if="vipParams.id"
						size="mini"
						@click="handleClick('vipPrice', vipParams)"
						type="warning"
						plain
						>会员权益
					</el-button>
				</span>
			</div>
		</el-dialog>
    <el-dialog
        :title="paymentMethodParams.id?'修改':'添加'"
        refs="handPaymentMethodEdit"
        :visible.sync="paymentMethodEdit"
        @closed="paymentMethodEdit=false"
        width="800px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <!-- 支付 -->
        <div class="public-dialog-form">
          <el-form ref="ruleForm" :model="paymentMethodParams" label-width="80px">
            <el-form-item label="商户" name="paymentMchId">
              <el-select
                  filterable
                  style="width: 100%"
                  v-model="paymentMethodParams.paymentMchId"
                  clearable
                  placeholder="请选择商户"
              >
                <el-option
                    v-for="(item, index) in allPayInfoList"
                    :key="index"
                    :label="item.mchName + '(' + item.mchId + ')'"
                    :value="item.paymentMchId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="支付类型" name="paymentType">
              <el-select
                  filterable
                  style="width: 100%"
                  v-model="paymentMethodParams.paymentType"
                  clearable
                  placeholder="请选择支付类型"
              >
                <el-option value="AP">applePay</el-option>
                <el-option value="GP">googlePay</el-option>
                <el-option value="PP">paypal</el-option>
                <el-option value="CC">creditCard</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="切换策略" name="changeCount">
              <el-input-number
                  :min="1"
                  :precision="0"
                  clearable
                  placeholder="访问X次切换付款商户"
                  v-model="paymentMethodParams.changeCount"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input
                  clearable
                  placeholder="排序"
                  v-model="paymentMethodParams.sort"
              ></el-input>
            </el-form-item>
            <el-form-item label="是否启用" name="status">
              <el-switch
                  v-model="paymentMethodParams.status"
                  active-text="启用"
                  :active-value="1"
                  inactive-text="禁用"
                  :inactive-value="0"
              ></el-switch>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="public-dialog-footer">
					<el-button size="medium" @click="paymentMethodEdit = false">取 消</el-button>
					<el-button size="medium" type="primary" @click="handPaymentMethodEdit">
						提 交
					</el-button>
				</span>
      </div>
    </el-dialog>
	</div>
</template>
<script>
import {PAGE_SIZE}          from "@config";
import {emptyShow, isEmpty} from "../../utils/tools/index";
import upLoadImg            from "./components/upLoadImg.vue";

export default {
	components: {
		upLoadImg,
	},
	data() {
		var checkAccount = (rule, value, callback) => {
			callback();
		};
		return {
			isEmpty,
			chilckType: "AIRWALLEX",
			payType: [
        {
          type: "AIRWALLEX",
          name: "airWallex",
        },
        {
          type: "PAYPAL",
          name: "paypal",
        },
        {
          type: "PAYIN",
          name: "payin",
        },
        {
          type: "USEEPAY",
          name: "useepay",
        },
        {
          type: "PAYINSIDER",
          name: "Payinsider",
        },
			],
			merchantVistab: false,
			vipVisble: false,
			radio_mode: 1,
			payMentListInfo: [],
			payAppInfoId: "",
			payTypeChangList: [],
			allPayInfoList: [],
			click: true,
			PAGE_SIZE,
			emptyShow,
			listParams: {
				appType: "WEBSIT",
			},
			companyData: [],
			appData: [],
			tableData: [],
			loading: false,
			pages: {
				pageNo: 1,
				pageSize: PAGE_SIZE,
			},
			total: 0,
			clickType: "",
			dialogVisible: false, //弹窗是否可见
			params: {}, //弹窗修改数据
			rules: {
				appName: [
					{ required: true, message: "请填写名称", trigger: "blur" },
					{},
				],
				appType: [{ required: true, message: "请选择类型", trigger: "blur" }],
				appInfoId: [
					{ message: "请输入应用ID", trigger: "blur" },
					{
						validator: checkAccount,
						message: "只允许输入英文,数字",
					},
					{ max: 50, message: "最多50个字符" },
				],
				swid: [
					{ message: "请输入应用推广标识", trigger: "blur", required: true },
					{
						validator: checkAccount,
						message: "只允许输入英文,数字",
					},
					{ max: 6, message: "最多6个字符" },
				],
				companyId: [{ required: true, message: "请选择主体", trigger: "blur" }],
				domainBizId: [
					{ required: true, message: "请选择业务域名", trigger: "blur" },
				],
			},
			allAppType: [], //字典字段--app类型
			allDomainList: [], //所有业务域名列表
			channelData: [], //渠道
			areadyPayChannnel: [], //已经关联过的渠道支付商户
			navIndex: 0, //广告-默认激活
			payMentList: [],
			flag: true,
			checkListNav: [],
			bindLanguageList: [], //用于存储已绑定语言
			payRules: {},
			payParams: {},
			vipParams: {},
			paymentVistab: false,
      paymentMethodVisible: false,
      paymentMethodEdit: false,
			paymentMerchantVisble: false,
			paymentClickType: "",
			languageList: [],
			languageCode: "",
			emailList: [],
      paymentMethodList: [],
			langList: [], //用于编辑应用绑定语言
			multipleMchList: [],
      paymentMethodParams: {},
		};
	},

	computed: {},
	created() {
		this.getAppType();
		this.companyList();
		this.appList();
		this.queryTableData();
		this.getLanguageList();
		this.getEmailList();
    this.getMchList();
	},

	watch: {
		dialogVisible() {
			if (this.dialogVisible == false && this.params != {}) {
				this.$refs["ruleForm"].resetFields();
				this.params = {};
				this.flag = false;
			}
		},
	},
	methods: {
    //查询商户类型列表
    async getMchList(){
      const {data: resData} = await this.$get(
          "/app/mch/list/types"
      );
      this.payType = resData.data.map(item => {
        return {
          type: item,
          name: item.charAt(0) + item.slice(1).toLowerCase()
        }
      })
    },
		async getEmailList() {
			this.loading = true;
			//角色列表
			const { data: res } = await this.$post(`/email/config/list`);
			this.loading = false;
			this.emailList = res.data;
		},
		handleTabClick(e) {
			if (e == "vip") {
				return this.changeVip();
			}
			if (this.payParams.appPaymentId) {
				this.getMerchantPayment();
			}
		},
		//选择商户
		handleSelectionChange(val) {
			this.multipleMchList = val;
		},
		async getMerchantPayment() {
			this.flag = false;
			this.loading = true;
			const { data: resData } = await this.$get(
				"/app/payment/mode/detail/" + this.payParams.appPaymentId,
				{
					headers: {
						isLoading: true,
						"Language-Code": this.languageCode,
					},
				}
			);
			this.loading = false;
			this.payParams = JSON.parse(JSON.stringify(resData.data));
			this.$nextTick(() => {
				this.flag = true;
			});
		},

		//获取语言列表
		async getLanguageList() {
			this.loading = true;
			//角色列表
			const { data: res } = await this.$post(`/language/list`, {
				adminStatus: 1,
			});
			this.loading = false;
			this.languageList = res.data;
			this.languageCode = res.data[0].code;
		},

		activePayEventNav() {
			this.payMentListInfo = [];
			this.getPlayment(this.payAppInfoId);
			this.getPlayItems();
		},
		/* 切换主体下的业务域名 */
		changeMain() {
			// 获取 相关联的业务域名
			this.$get("domain/biz/list", {
				params: {
					status: 1,
					paging: false,
				},
			}).then((res) => {
				if (res.data.data != undefined) {
					this.allDomainList = res.data.data;
				} else {
					this.allDomainList = [];
				}
			});
		},
		changeVip() {
			// 获取 vip
			this.$get("/merchant/product/list/" + this.params.appInfoId, {
				headers: {
					"Language-Code": this.languageCode,
				},
			}).then((res) => {
				if (res.data.data != undefined) {
					if (res.data.data.description) {
						res.data.data.description = JSON.parse(
							res.data.data.description,
							null,
							"\t"
						);
					}
					this.vipParams = res.data.data;
				} else {
					this.vipParams = {};
				}
			});
		},
		/* 获取选择项--支付商户--选项  不会更改的 */
		getPlayItems() {
			let http = "/payment/mch/list";
			this.$get(`${http}`, {
				params: {
					status: 1,
					paging: false,
					mchType: this.chilckType,
				},
			}).then((res) => {
				this.loading = false;
				if (!isEmpty(res.data.data)) {
					this.allPayInfoList = res.data.data;
				} else {
					this.allPayInfoList = [];
				}
			});
		},
		/* 已经关联的 支付商户 */
		getPlayment(appInfoId) {
			this.loading = true;
			this.payAppInfoId = appInfoId;
			this.$get(
				`/app/mch/list/paymentMch?appInfoId=${appInfoId}&mchType=${this.chilckType}`,
				{
					status: 1,
					paging: false,
				}
			).then((res) => {
				this.loading = false;
				this.payMentListInfo = res.data.data;
				// if (!isEmpty(res.data.data)) {
				//   if (res.data.data.appPaymentVos) {
				//     this.payMentListInfo = res.data.data.appPaymentVos
				//   } else {
				//     this.payMentListInfo = []
				//   }
				// } else {
				//   this.payMentListInfo = []
				// }
			});
		},
		/* 获取      的 渠道--渠道账户 */
		async getChannelData(companyId, callback) {
			this.loading = true;
			const { data: resData } = await this.$get(
				`/channel/account/list`,
				// `/channel/account/list?companyId=${companyId}`,
				{
					params: {
						status: 1,
						paging: false,
					},
				}
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.channelData = resData.data;

			if (callback) callback();
		},
		/* 获取该app下已经关联的渠道 */
		async getAreadyChannel(appInfoId) {
			const { data: resData } = await this.$get(
				`/app/channel/list?appInfoId=${appInfoId}`,
				{
					params: {
						status: 1,
						paging: false,
					},
				}
			);
			if (resData.result != 200) return;
			this.params.channelAccountIds = []; //渠道--

			if (!isEmpty(resData.data)) {
				this.areadyPayChannnel = resData.data; //支付--渠道

				this.navIndex = 0; // 默认激活

				let temp = resData.data;
				temp.forEach((element) => {
					this.params.channelAccountIds.push(element.channelAccountId);
				});
			} else {
				this.areadyPayChannnel = [];
				this.params.channelAccountIds = [];
			}
		},
		/* *
      app类型选项  / 业务域名
     */
		async getAppType() {
			const { data: res } = await this.$get("/enums/list/APP_TYPE");
			this.allAppType = res.data;
		},

		SearchAppList() {
			this.pages.pageNo = 1;
			this.queryTableData();
		},
		/**
		 * 应用管理列表
		 */
		async queryTableData() {
			this.loading = true;
			const { data: resData } = await this.$get("/app/list", {
				params: {
					...this.listParams,
					...this.pages,
				},
			});
			this.loading = false;
			if (resData.result != 200) return;
			this.tableData = resData.data;
			this.total = resData.page.count;
		},
		/**
		 * 主体列表（企业列表）
		 */
		async companyList() {
			this.loading = true;
			const { data: resData } = await this.$get("/company/list?paging=false");
			this.loading = false;
			if (resData.result != 200) return;
			this.companyData = resData.data;
		},
		/**
		 * 获取应用类型
		 */
		async appList() {
			this.loading = true;
			const { data: resData } = await this.$get(`/enums/list/APP_TYPE`);
			this.loading = false;
			if (resData.result != 200) return;
			this.appData = resData.data;
		},
		/**
		 * 表格按钮点击
		 */
		async handleClick(type, row = {}) {
			this.clickType = type;
			switch (type) {
				case "add":
					this.dialogVisible = true;
					this.flag = false;
					row.validStatus = 1;
					this.params = JSON.parse(JSON.stringify(row));
					this.$nextTick(() => {
						this.flag = true;
					});
					break;
				case "edit":
					this.dialogVisible = true;
					this.changeMain();
					this.flag = false;
					this.params = JSON.parse(JSON.stringify(row));
					this.$nextTick(() => {
						this.flag = true; //组件生命重新加载
					});
					break;
				case "channel":
					this.flag = false;
					this.params = JSON.parse(JSON.stringify(row));
					// 先获取其主体下 已经关联的渠道
					if (this.params.companyVo) {
						await this.getChannelData(this.params.companyVo.companyId); //获取渠道账户列表
					}
					if (isEmpty(this.channelData)) {
						this.$message.warning("暂无可关联的渠道");
						return;
					}
					await this.getAreadyChannel(this.params.appInfoId);
					this.dialogVisible = true;
					break;
				case "pay":

				case "nav":
					this.flag = false;
					this.params = JSON.parse(JSON.stringify(row));
					await this.getNavList();
					if (isEmpty(this.navList)) {
						this.$message.warning("暂无导航，请先配置");
						return;
					}
					await this.areadyNav(this.params.appInfoId);
					this.dialogVisible = true;
					break;
				case "service":
					break;
				case "agreement":
					break;
				case "content":
					let temp = {
						appName: row.appName,
						appTypeName: row.appTypeName,
						appid: row.appid,
						appInfoId: row.appInfoId,
					};
					if (!isEmpty(row.companyId)) {
						temp.companyId = row.companyId;
					}
					this.$router.push({
						name: "WEB_APP_CONTENT",
						query: temp,
					});
					break;
				case "lang":
					this.flag = false;
					this.params = JSON.parse(JSON.stringify(row));
					console.log("this.params", this.params);
					await this.areadyLang(this.params.appInfoId);
					this.dialogVisible = true;
					break;
				case "vip":
					this.vipVisble = true;
					this.params = JSON.parse(JSON.stringify(row));
					this.changeVip();
					break;
				case "vipPrice":
					let query = {
						appName: row.name,
						appTypeName: row.code,
						appid: row.id,
						appInfoId: row.appInfoId,
					};
					if (!isEmpty(row.companyId)) {
						query.companyId = row.companyId;
					}
					this.vipVisble = false;
					this.$router.push({
						name: "VIP_APP_CONTENT",
						query,
					});
					break;
				case "advertising":
					break;
				case "keyword":
					break;
			}
		},

		async handlePaymentClick(row) {
			this.loading = true;
			this.params = JSON.parse(JSON.stringify(row));
			this.getPlayItems(); //先获取下拉菜单可选项
			this.getPlayment(this.params.appInfoId);
			this.paymentVistab = true;
		},
    async handlePaymentMethodClick(row) {
      this.loading = true;
      this.chilckType = null;
      this.params = JSON.parse(JSON.stringify(row));
      this.getPlayItems(); //先获取下拉菜单可选项
      this.getPaymentMethod(this.params.appInfoId);
      this.paymentMethodVisible = true;
    },
    /* 已经关联的 支付商户 */
    getPaymentMethod(appInfoId) {
      this.loading = true;
      this.payAppInfoId = appInfoId;
      this.$get(
          `/app/payment/plan/list/${appInfoId}`,
          {
            status: 1,
            paging: false,
          }
      ).then((res) => {
        this.loading = false;
        this.paymentMethodList = res.data.data;

      });
    },
    handPaymentMethodClick(e, row) {
      this.paymentClickType = e;
      if (e === "add") {
        this.paymentMethodParams = {
          status: 1,
          changeCount: 1,
        };
        this.paymentMethodEdit = true;
      } else {
        this.paymentMethodParams = JSON.parse(JSON.stringify(row));
        this.paymentMethodEdit = true;
      }
    },
    async handPaymentMethodEdit() {
      const {data: res} = await this.$post("/app/payment/plan/submit", {
        ...this.paymentMethodParams,
        appInfoId: this.params.appInfoId,
      });
      if (res.result !== 200) return;
      this.$message.success("更新成功!");
      this.paymentMethodEdit = false;
      this.getPaymentMethod(this.params.appInfoId);
    },
		handPaymentClick(e, row) {
			this.paymentClickType = e;
			if (e == "add") {
				this.flag = false;
				this.payParams = {};
				this.$nextTick(() => {
					this.flag = true;
				});
				this.paymentMerchantVisble = true;
			} else {
				this.payParams = JSON.parse(JSON.stringify(row));
				this.getMerchantPayment();
				this.paymentMerchantVisble = true;
			}
		},
		//更新商户排序
		async saveSort(row) {
			const { data: resData } = await this.$get(
				`/app/mch/update/order/${row.id}?sortValue=${row.sort}`,
				{
					headers: {
						isLoading: true,
					},
				}
			);
			if (resData.result != 200) return;
			this.$message.success("更新排序成功!");
		},
    handlePaymentMethodDelete(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/app/payment/plan/removeById/${row.id}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getPaymentMethod(this.params.appInfoId);
        this.$message.success("删除成功!");
      });
    },
		/* 删除 */
		handlePaymentDelete(row) {
			this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
				type: "warning",
			}).then(async () => {
				const { data: resData } = await this.$delete(
					`/app/mch/removeById/${row.id}`,
					{
						headers: {
							isLoading: true,
						},
					}
				);
				if (resData.result != 200) return;
				this.getPlayment(this.params.appInfoId);
				this.$message.success("删除成功!");
			});
		},
		/* 导航配置 */
		async getNavList() {
			this.navList = [];
			const { data: res } = await this.$get("/app/nav/list", {
				params: {
					status: 1,
					paging: false,
				},
			});
			if (!isEmpty(res.data)) {
				this.navList = res.data;
			}
		},
		//查询语言列表
		async getLangList() {
			this.langList = [];
			const { data: res } = await this.$get("/app/language/list", {
				params: {
					status: 1,
					paging: false,
				},
			});
			if (!isEmpty(res.data)) {
				this.langList = res.data;
			}
		},
		async areadyNav(appInfoId) {
			this.checkListNav = [];
			const { data: resData } = await this.$get(
				`/app/unite/nav/ids?appInfoId=${appInfoId}`,
				{
					params: {
						status: 1,
						paging: false,
					},
				}
			);
			if (!isEmpty(resData.data)) {
				resData.data.forEach((element) => {
					this.checkListNav.push(element);
				});
			}
		},
		async areadyLang(appInfoId) {
			this.checkListNav = [];
			const { data: resData } = await this.$get(
				`/app/lang/codes?appInfoId=${appInfoId}`
			);
			this.bindLanguageList = resData.data;
		},
		/* 弹窗点击提交 */
		//窗口--提交 修改信息
		handleEdit() {
			this.$refs.ruleForm.validate((valid) => {
				if (!valid) return;
				this.$confirm("确认提交修改, 是否继续?", "提示", {
					type: "info",
				}).then(async () => {
					let type = this.clickType;
					if (type == "add") {
						const { data: res } = await this.$post("/app/info", this.params);
						if (res.result != 200) return;
						this.$message.success("添加成功!");
					} else if (type == "edit") {
						const { data: res } = await this.$put("/app/info", this.params);
						if (res.result != 200) return;
						this.$message.success("修改成功!");
					} else if (type == "channel") {
						const { data: res } = await this.$post("/app/channel/info", {
							appInfoId: this.params.appInfoId,
							channelAccountIds: this.params.channelAccountIds,
						});
						if (res.result != 200) return;
						this.$message.success("关联渠道账户成功!");
					} else if (type == "nav") {
						const { data: res } = await this.$post("/app/unite/nav/ids", {
							appInfoId: this.params.appInfoId,
							ids: this.checkListNav,
						});
						if (res.result != 200) return;
						this.$message.success("关联导航成功!");
					} else if (type == "pay") {
					} else if (type == "lang") {
						const { data: res } = await this.$post("/app/binding/languages", {
							appInfoId: this.params.appInfoId,
							langCodes: this.bindLanguageList,
						});
						if (res.result != 200) return;
						this.$message.success("关联语言成功!");
					} else if (type == "service") {
					} else if (type == "agreement") {
					}
					if (type != "pay") {
						this.queryTableData();
						this.dialogVisible = false; //弹窗隐藏
					}
				});
			});
		},
		//支付方式关联商户
		async handleMchID() {
			const { data: res } = await this.$post(
				"/app/mch/save",
				{
					appInfoId: this.params.appInfoId,
					sort: this.payParams.sort,
					paymentMchId: this.payParams.paymentMchId,
				},
				{
					headers: {
						isLoading: true,
						"Language-Code": this.languageCode,
					},
				}
			);
			if (res.result != 200) return;
			this.$message.success("关联支付成功!");
			this.getPlayment(this.params.appInfoId);
			this.paymentMerchantVisble = false;
			this.payParams = {};
		},

		async handleVip() {
			const api = this.vipParams.id
				? "/merchant/product/update"
				: "/merchant/product/create";
			const { data: res } = await this.$post(
				api,
				{
					...this.vipParams,
					appInfoId: this.params.appInfoId,
					name: this.vipParams.name,
					description: JSON.stringify(this.vipParams.description),
				},
				{
					headers: {
						isLoading: true,
						"Language-Code": this.languageCode,
					},
				}
			);
			if (res.result != 200) return;
		},
		async handlePaymentEdit() {
			this.payParams.main = 0;
			const { data: res } = await this.$post(
				"/app/payment/mode/info",
				{
					appInfoId: this.params.appInfoId,
					paymentType: this.chilckType,
					mode: 1,
					paymentMchIds: [this.payParams],
				},
				{
					headers: {
						isLoading: true,
						"Language-Code": this.languageCode,
					},
				}
			);
			if (res.result != 200) return;

			this.payParams.appPaymentId = res.data[0];
			this.getMerchantPayment();
			this.$message.success("关联支付成功!");
			this.getPlayment(this.params.appInfoId);
		},
		// 外层表格状态
		changePaymentSwitch(row) {
			this.$get(`/app/mch/update/status/${row.id}`).then((res) => {
				if (res.data.result == 200) {
					this.$message.success("操作成功");
					this.getPlayment(this.params.appInfoId);
				}
			});
		},
		/* 删除 */
		handleDelete(row) {
			this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
				type: "warning",
			}).then(async () => {
				const { data: resData } = await this.$delete(
					`/app/info/${row.appInfoId}`,
					{
						headers: {
							isLoading: true,
						},
					}
				);
				if (resData.result != 200) return;
				this.queryTableData();
				this.$message.success("删除成功!");
			});
		},

		/* 广告--渠道+code  的点击 */
		activeEventNav(index, channelAccountId) {
			this.navIndex = index;
			this.loading = true;
			this.getPlayment(this.params.appInfoId);
			// 重新调用渲染接口添加默认数据
			this.getPlayItems();
		},

		// 外层表格状态
		changeSwitch(row) {
			this.$put(`/app/info/status/${row.appInfoId}`).then((res) => {
				if (res.data.result == 200) {
					this.$message.success("操作成功");
				}
			});
		},

		//分页
		handleSizeChange(val) {
			this.pages.pageSize = val;
			this.queryTableData();
		},
		handleCurrentChange(val) {
			this.pages.pageNo = val;
			this.queryTableData();
		},
	},
	};
</script>

<style lang="scss" scoped>
.tag-marr {
	margin-right: 5px;
	cursor: pointer;
}

.active-bg1 {
	background: #fbc4c4;
	color: #fff;
}

.order-orderlist {
	height: 300px;
	//background-color: #3a8ee6;
}

.oerdasf {
	width: 500px;
	margin: 20px auto;
}

.el-button {
	margin-right: 10px;
	margin-left: 0;
}

.info_tabs_wechat {
	cursor: pointer;

	.radio_box {
		display: flex;
		align-items: center;
		margin-bottom: 20px;
		font-size: 14px;

		div:nth-child(1) {
			width: 98px;
			text-align: right;
			padding-right: 14px;
		}
	}

	.box_chang_info {
		display: flex;
		margin-bottom: 20px;
		font-size: 14px;

		> div:nth-child(1) {
			width: 98px;
			text-align: right;
			padding-right: 14px;
		}

		.tab_info {
			border: 1px solid #959595;
			border-bottom: 0;
			background: #ffffff;

			.tab_head_tou {
				display: flex;
				//align-items: center;
				box-sizing: border-box;
				border-bottom: 1px solid #959595;

				.td_head {
					text-align: center;
					//height: 44px;
					min-height: 44px;
					display: flex;
					justify-content: center;
					align-items: center;
					border-right: 1px solid #959595;
				}

				.one_line {
					width: 80px;
				}

				.two_line {
					width: 280px;
				}

				.last_line {
					border-right: 0;
				}
			}

			._tab_add {
				height: 44px;
				font-size: 28px;
				display: flex;
				align-items: center;
				justify-content: center;
				color: #959595;
			}
		}
	}
}

.left_box_infos {
	width: 90%;
	cursor: pointer;
	height: 400px;
	overflow-y: scroll;
	border: 1px solid #959595;
	padding: 10px;

	.cou_infos {
		margin-bottom: 10px;
	}
}

.line_td {
	padding: 5px;
	border-bottom: 1px solid #959595;
}

.last_line_to {
	border-bottom: 0;
}

.box_chang_info {
	display: flex;
	margin-bottom: 20px;
	font-size: 14px;

	.tab_info {
		border: 1px solid #959595;
		border-bottom: 0;
		background: #ffffff;

		.tab_head_tou {
			display: flex;
			align-items: center;
			box-sizing: border-box;
			border-bottom: 1px solid #959595;

			.td_head {
				text-align: center;
				height: 44px;
				line-height: 44px;
				border-right: 1px solid #959595;

				img {
					width: 80%;
					height: 80%;
					object-fit: contain;
				}
			}

			.one_line {
				width: 80px;
			}

			.class_box {
				width: 120px;
			}

			.serial {
				width: 60px;
			}

			.name_box {
				width: 160px;
			}

			.two_line {
				width: 280px;
			}

			.last_line {
				border-right: 0;
				width: 160px;
			}
		}

		.content {
			.two_line {
				width: 80px;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}

		._tab_add {
			height: 44px;
			font-size: 28px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: #959595;
		}
	}
}

.box_chang_info > div:nth-child(1) {
	width: 80px;
	text-align: right;
}

.app_info_name {
	font-size: 14px;
	font-weight: bold;
}
</style>
